// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8d013eab","640":"7925f8fb"}[chunkId] + ".chunk.js";
};